import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['input', 'content']
  static values = {
    searchUrl: String
  }
  
  connect(){
    useClickOutside(this)
  }

  openDropdown(){
    this.contentTarget.classList.remove('opacity-0')
    this.contentTarget.classList.remove('h-0')
  }
  
  closeDropdown(){
    this.contentTarget.classList.add('opacity-0')
    this.contentTarget.classList.add('h-0')
  }

  getAgentsList(e){
    this.openDropdown()
let url = this.searchUrlValue + '?name=' + this.inputTarget.value
    get(url, { responseKind: 'turbo-stream' })
  }

  selectAgent(e){
    //Set name
    this.inputTarget.value = e.currentTarget.dataset.name
    this.closeDropdown()
  }

  clickOutside(e) {
    this.closeDropdown()
  }
}
